import axios from 'axios'
import { Notification } from 'element-ui'
import router from '../router/lazy'
const service = axios.create({
  baseURL: window.XCConfig.BASE_API,
  timeout: 180000,
  withCredentials: true
})
// service.interceptors.request.use(config => {
//   config.headers['Authorization'] = 'Bearer' + getToken()
//   return config
// }, error => {
//   Promise.reject(error)
// })
service.interceptors.response.use(
  response => {
    if (response.data.code === 2000) {
      // 未登录
      Notification.error({
        title: '未登录',
        message: '没有登录，或没有进行认证'
      })
      let historyPath = router.currentRoute.path
      if (historyPath !== '/' && historyPath !== '/dashboard/workplace' && historyPath !== '/login') {
        sessionStorage.setItem('historyPath', historyPath)
      }
      router.replace({path: '/login'})
      return Promise.reject(response)
    }
    if (response.data.code === 2001) {
      Notification.error({
        title: '权限异常',
        message: response.data.message
      })
      return Promise.reject(response)
    }
    if (response.data.showHits) {
      if (response.data.level === 'info') {
        Notification.success({
          title: '信息',
          message: response.data.message
        })
      }
      if (response.data.level === 'fail') {
        Notification.error({
          title: '错误',
          message: response.data.message
        })
      }
      if (response.data.level === 'warn') {
        Notification.warning({
          title: '警告',
          message: response.data.message
        })
      }
    }
    if (response.data.code === 0) {
      return response
    } else {
      return Promise.reject(response)
    }
  },
  error => {
    if (error.response) {
      if (error.response.status === 403) {
        Notification.error({ title: '拒绝访问', message: '无权限，拒绝访问' })
      }
      // if (error.response.status === 401) {
      //   router.push('/401')
      //   Notification.error({ title: '未授权', message: '授权验证失败' })
      // }
      if (error.response.status === 401) {
        router.push('/login')
        // Notification.error({ title: '未授权', message: '授权验证失败' })
      }
      if (error.response.status === 500) {
        Notification.error({ title: '系统异常', message: '服务器出错' })
        router.push('/500')
      }
      if (error.response.status === 404) {
        Notification.error({ title: '未找到', message: '未找到服务器资源' })
      }
    }
    return Promise.reject(error)
  })
export default service



// WEBPACK FOOTER //
// ./src/utils/request.js